export enum BoiCollectConfigurationGroupEnum {
  settings = 'Settings'
}
